import * as React from 'react';
import { connect } from 'react-redux';

import { NewSeoUrlsContainer } from '../../components/new_seo_urls/new_seo_urls';
import { ISeoUrl } from '../../models/seo_data';
import { IStore } from '../../models/store';

export interface INewSeoUrlsProps {
  newSeoUrls: ISeoUrl[];
}

const NewSeoUrls = (props: INewSeoUrlsProps) => (
  props.newSeoUrls.length > 0
    ? <NewSeoUrlsContainer links={props.newSeoUrls} />
    : <div />
);

const mapStateToProps = (state: IStore) => ({
  newSeoUrls: state.mainpage.newSeoUrls,
});

export const NewSeoUrlsWrapper = connect<INewSeoUrlsProps, {}, {}>(mapStateToProps)(NewSeoUrls);
